var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0007a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGOUT",
    transform: "translate(-1475 -342)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1475 342)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M7821.888,24422.2a1.5,1.5,0,0,1-1.5-1.5v-11.145a1.5,1.5,0,0,1,1.5-1.494h7.827a1.5,1.5,0,0,1,1.5,1.494v1.834h-1.091v-1.33a1,1,0,0,0-1-1h-6.73a1,1,0,0,0-1,1v10.051a1,1,0,0,0,1,1h6.73a1,1,0,0,0,1-1v-1.238h1.091v1.828a1.5,1.5,0,0,1-1.5,1.5Zm6.3-4.18c-.331-.3-.08-.791-.08-.791l1.446-1.562h-4.86s-.515-.109-.515-.57.515-.533.515-.533h4.86l-1.446-1.715a.54.54,0,0,1,.08-.73.508.508,0,0,1,.711,0l2.274,2.445a.638.638,0,0,1,.294.533.663.663,0,0,1-.294.57l-2.274,2.354a.692.692,0,0,1-.38.131A.489.489,0,0,1,7828.189,24418.02Z",
    transform: "translate(-6339.393 -24061.061)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.93c377ffcb86d05a7bd31beaf1a91ad3.svg";
export { ForwardRef as ReactComponent };